import { InitiateCashCollection } from "../layout";
import PageLayout from "./PageLayout";

const CashCollection = () => {
  return (
    <PageLayout>
      <InitiateCashCollection />
    </PageLayout>
  );
};

export default CashCollection;
